export const PUBLIC_SEGMENTS = ["philippines", "eastern_europe"] as const;

export type PublicSegment = (typeof PUBLIC_SEGMENTS)[number];

type Dashed<T extends string> = T extends `${infer Head}_${infer Rest}`
  ? `${Head}-${Dashed<Rest>}`
  : T;

export type SegmentSlug = Dashed<PublicSegment>;

export function segmentSlug(segment: PublicSegment): SegmentSlug {
  return segment.replace(/_/g, "-") as SegmentSlug;
}

export function galleryPath(segment: PublicSegment): string {
  return `/${segmentSlug(segment)}/profiles`;
}

export function profilePath(segment: PublicSegment, publicId: string): string {
  return `${galleryPath(segment)}/${publicId}`;
}

export type PublicNavLink = { to: string; label: string };

export const PUBLIC_NAV_LINKS: PublicNavLink[] = [
  { to: galleryPath("philippines"), label: "Philippines" },
  { to: galleryPath("eastern_europe"), label: "Eastern Europe" },
];
